import { FatFingerProductSectorLimit } from 'api'
import { get, set } from 'lodash-es'

export function immUpdate<T>(obj: T, path: string, value: any): T {
  const parts = path.split('.')
  return updateInternal(obj, parts, value)
}

function updateInternal(obj: any, parts: string[], value: any): any {
  const part = parts[0]
  const newValue = parts.length === 1 ? value : updateInternal(get(obj, part), parts.slice(1), value)

  if (obj && newValue === get(obj, part)) {
    return obj
  } else {
    const updater: any = {}
    set(updater, part, newValue)
    return Object.assign({}, obj, updater)
  }
}

export const createObjectCache = <T extends Record<string, unknown>>(objectFactory: () => T, newExpiryTimeGetter: () => number): T => {
  let cache = objectFactory()
  let cacheExpiry = newExpiryTimeGetter()

  return new Proxy(cache, {
    get: (_, key: string) => {
      const now = new Date().getTime()
      if (now > cacheExpiry) {
        cacheExpiry = newExpiryTimeGetter()
        cache = objectFactory()
      }
      return cache[key]
    }
  })
}

export const toSide = <T>({ initiator, responder, ownOrder }: { initiator: T; responder: T; ownOrder: boolean }) => {
  if (ownOrder) return initiator ?? null
  return responder ?? null
}

export const getDefaultFatFingerSector = (defaultFatFingers: FatFingerProductSectorLimit[], id: string) => {
  const fatFingerFound = defaultFatFingers.find(x => x.productSectorId === id)

  if (fatFingerFound) {
    return fatFingerFound
  } else {
    return defaultFatFingers.find(x => x.productSectorId === 'DEFAULT_ID')
  }
}
